import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {HttpStatusCodes} from '../../util/uiconstants';
import {isApiResponseOk} from '../../util/utils';
import _ from 'lodash';

export function flowchartstepReducer(state = initialstate.flowchartStep, action) {
	switch (action.type) {
		case types.GET_FLOWCHART_STEP_BY_ID: {
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				return action.response;
			}
			return state;
		}

		case types.EDIT_FLOWCHART_STEP: {
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				const mergedState = _.merge({}, state, action.response);
				return {
					...mergedState,
					flowchartStepName: action.flowchartStepName ?? mergedState.flowchartStepName,
					flowchartStepDescription: action.flowchartStepDescription ?? mergedState.flowchartStepDescription
				};
			}
			return state;
		}

		case types.DELETE_FLOWCHART_STEP: {
			if (action.responseObj.status === HttpStatusCodes.NoContent) {
				return state;
			}
			return state;
		}

		case types.RELATE_ITAPP_TO_FLOWCHART_STEP: {
			if (isApiResponseOk(action)) {
				return state;
			}
			return state;
		}

		case types.UNRELATE_IT_APPLICATION_FROM_FLOWCHART_STEP: {
			if (isApiResponseOk(action)) {
				return state;
			}
			return state;
		}

		case types.RELATE_CONTROL_TO_FLOWCHART_STEP: {
			if (isApiResponseOk(action)) {
				return state;
			}
			return state;
		}

		case types.RELATE_DOCUMENT_TO_FLOWCHART_STEP: {
			if (isApiResponseOk(action)) {
				return state;
			}
			return state;
		}

		case types.UNRELATE_CONTROL_FROM_FLOWCHART_STEP: {
			if (isApiResponseOk(action)) {
				return state;
			}
			return state;
		}

		case types.UNRELATE_DOCUMENT_TO_FLOWCHART_STEP: {
			if (isApiResponseOk(action)) {
				return state;
			}
			return state;
		}

		case types.UPDATE_STORE_UNRELATED_CONTROL_FROM_FLOWCHARTSTEP_CONTROL: {
			return {
				...state,
				flowchartStepsControl: _.filter(
					state.flowchartStepsControl,
					(item) =>
						item.flowchartStepId === action.response.flowchartStepId && item.controlId !== action.response.controlId
				)
			};
		}

		case types.UPDATE_STORE_RELATED_FLOWCHARTSTEP_CONTROL: {
			const exists = state.flowchartStepsControl.some(item => item.controlId === action.response.controlId);
			if (exists) {
				return state;
			}
			return {
				...state,
				flowchartStepsControl: [...state.flowchartStepsControl, action.response].sort((a, b) =>
					a.controlName.toLowerCase().localeCompare(b.controlName.toLowerCase())
				)
			};
		}
		case types.UPDATE_STORE_RELATED_FLOWCHARTSTEP_IT_APPLICATION_SO: {
			if (!action.response.isServiceOrganization) {
				const exists = state.flowchartStepsITApplication.some(item => item.itApplicationId === action.response.itApplicationId);
			if (exists) {
				return state;
			}
				return {
					...state,
					flowchartStepsITApplication: [...state.flowchartStepsITApplication, action.response].sort((a, b) =>
						a.itApplicationName?.toLowerCase().localeCompare(b.itApplicationName?.toLowerCase())
					)
				};
			} else {
				const exists = state.flowchartStepsSO.some(item => item.itApplicationId === action.response.itApplicationId);
				if (exists) {
					return state;
				}
				return {
					...state,
					flowchartStepsSO: [
						...state.flowchartStepsSO,
						{...action.response, soName: action.response.itApplicationName}
					].sort((a, b) => a.soName?.toLowerCase().localeCompare(b.soName?.toLowerCase()))
				};
			}
		}

		case types.UPDATE_STORE_UNRELATED_IT_APPLICATION_FROM_FLOWCHARTSTEP_IT_APPLICATION_SO: {
			if (!action.response.isServiceOrganization) {
				return {
					...state,
					flowchartStepsITApplication: _.filter(
						state.flowchartStepsITApplication,
						(item) =>
							item.flowchartStepId === action.response.flowchartStepId &&
							item.itApplicationId !== action.response.itApplicationId
					)
				};
			} else {
				return {
					...state,
					flowchartStepsSO: _.filter(
						state.flowchartStepsSO,
						(item) =>
							item.flowchartStepId === action.response.flowchartStepId &&
							item.itApplicationId !== action.response.itApplicationId
					)
				};
			}
		}
		case types.CLEAR_FLOWCHART_STEP: {
			return initialstate.flowchartStep;
		}
		case types.RELATE_RISK_TO_FLOWCHART_STEP: {
			if (isApiResponseOk(action)) {
				return state;
			}
			return state;
		}
		default:
			return state;
	}
}
